import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/AgentGatewayConfiguration.ts
var n = class extends t {
	async put(t, n) {
		let r = `/agentgateway/restricted/organizations/${e.orgPlaceholder}/commerce/tracking-ids/${t}/configuration`;
		await this.api.put(r, n);
	}
};
//#endregion
export { n as AgentGatewayConfiguration };

//# sourceMappingURL=AgentGatewayConfiguration.js.map